// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__kpU4G","title":"About_title__2Yasg","body":"About_body__3Y0RR"};